import { render } from "./AsideBIBO.vue?vue&type=template&id=454c9ef3&ts=true"
import script from "./AsideBIBO.vue?vue&type=script&lang=ts"
export * from "./AsideBIBO.vue?vue&type=script&lang=ts"

import "./AsideBIBO.vue?vue&type=style&index=0&id=454c9ef3&lang=css"

import exportComponent from "C:\\NEW DTC 2021\\ecpv\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__